import React from 'react';
import { FormattedMessage } from 'react-intl'

const personalSelect = (props) => {
  return (
    <div className="form-group">
      <select className="form-control mt-2" id="exampleFormControlSelect1" onChange={props.change} value={props.default}>
        <option value="0">{/*<FormattedMessage id="choose-department" />*/}Todos os Departamentos</option>
        {props.options}
      </select>
    </div>
  )
}

export default personalSelect;



// WEBPACK FOOTER //
// ./src/components/UI/PersonalSelect.js